import style from './AppBar.css';
import BackIcon from '../Icons/BackIcon';
import CrossIcon from '../Icons/CrossIcon';

export default function AppBar({
  className = '',
  title = '',
  onBackClick,
  onCloseClick,
  closeRef = null,
  backRef = null,
  customActions = [],
}) {
  return (
    <div className={`${className} ${style['app-bar']}`}>
      <div className={style.content}>
        <div className={style.left}>
          {onBackClick && (
            <BackIcon
              className={`${style.icon} ${style['back-icon']}`}
              onClick={onBackClick}
              ref={backRef}
              data-testid="back-icon"
            />
          )}
        </div>

        <p className={style.title}>{title}</p>

        <div className={style.right}>
          {customActions.map(
            action => action && <div className={style.icon}>{action}</div>,
          )}
          {onCloseClick && (
            <CrossIcon
              className={style.icon}
              onClick={onCloseClick}
              ref={closeRef}
              data-testid="close-icon"
            />
          )}
        </div>
      </div>
    </div>
  );
}
